import React from "react";
import styled from "styled-components";
import agenda from "../images/agenda.pdf";

const RegisterSection = styled.section`
  padding: 100px 0;
  background-color: var(--surface);
`;

const RegisterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-align: center;
  color: var(--text);

  span {
    color: var(--primary);
    position: relative;

    &:after {
      content: "";
      position: absolute;
      bottom: 5px;
      left: 0;
      width: 100%;
      height: 8px;
      background: linear-gradient(90deg, var(--primary), var(--accent));
      z-index: -1;
      opacity: 0.2;
    }
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.1rem;
  color: var(--textSecondary);
  text-align: center;
  max-width: 700px;
  margin: 0 auto 3rem;
`;

const RegisterForm = styled.form`
  max-width: 600px;
  margin: 0 auto;
  padding: 2.5rem;
  background-color: var(--background);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(30, 64, 175, 0.1);
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text);
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid rgba(30, 64, 175, 0.1);
  border-radius: 10px;
  background-color: var(--surface);
  color: var(--text);
  font-family: "Inter", sans-serif;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);
  }

  &::placeholder {
    color: var(--textSecondary);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid rgba(30, 64, 175, 0.1);
  border-radius: 10px;
  background-color: var(--surface);
  color: var(--text);
  font-family: "Inter", sans-serif;
  min-height: 120px;
  resize: vertical;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);
  }

  &::placeholder {
    color: var(--textSecondary);
  }
`;

const SubmitButton = styled.button`
  background: linear-gradient(90deg, var(--primary), var(--secondary));
  color: white;
  padding: 0.75rem 2rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: none;
  cursor: pointer;
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 40px;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(30, 64, 175, 0.2);
  }
`;

function Register() {
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   alert("Prijava je uspešno poslata! Kontaktiraćemo vas uskoro.");
  // };
  const handleOpenPDF = () => {
    window.open(agenda, "_blank");
  };

  return (
    <RegisterSection id="register">
      <RegisterContainer>
        <SectionTitle>
          Posjetite <span>UNINPHACKATHON</span>
        </SectionTitle>
        <SectionSubtitle>
          U prilogu možete pronaći agendu događaja. Poridružite nam se!!!
        </SectionSubtitle>

        <SubmitButton onClick={handleOpenPDF}>
          {/* <img
            src="https://img.icons8.com/win10/200/FFFFFF/google-logo.png"
            alt="google"
          /> */}
          AGENDA
        </SubmitButton>
        {/* <RegisterForm onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="name">Ime i prezime</Label>
            <Input
              type="text"
              id="name"
              placeholder="Unesite vaše ime i prezime"
              required
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="email">Email adresa</Label>
            <Input
              type="email"
              id="email"
              placeholder="primer@email.com"
              required
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="phone">Broj telefona</Label>
            <Input type="tel" id="phone" placeholder="+381 60 123 4567" />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="skills">Veštine i tehnologije</Label>
            <Input
              type="text"
              id="skills"
              placeholder="npr. React, Node.js, UI/UX dizajn..."
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="motivation">Zašto želite da učestvujete?</Label>
            <TextArea
              id="motivation"
              placeholder="Opišite vašu motivaciju i šta očekujete od radionica..."
              required
            />
          </FormGroup>

          <SubmitButton type="submit">Pošalji prijavu</SubmitButton>
        </RegisterForm> */}
      </RegisterContainer>
    </RegisterSection>
  );
}

export default Register;
